














































































































import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

import { cloneDeep, debounce } from 'lodash';
import { BForm, BFormInput, BCol, BRow, BFormCheckbox, BCollapse, VBTooltip } from 'bootstrap-vue';
import { ZenFormGroup } from 'zenComponents';
import ZenMultiselect from '@reciprocity/multiselect';
import RichText from '@/components/rich_text/RichText.vue';
import { TaskTemplate } from '../types';
import PeopleDropdown from '../../../components/presenters/PeopleDropdown.vue';

const RiskTaskTemplate = Vue.extend({
  name: 'RiskTaskTemplate',
  components: {
    BCollapse,
    BForm,
    BFormInput,
    RichText,
    ZenFormGroup,
    BCol,
    BRow,
    BFormCheckbox,
    PeopleDropdown,
    ZenMultiselect,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    value: {
      type: Object as PropType<TaskTemplate>,
      required: true,
      default: () => {},
    },
    users: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    const template: TaskTemplate = cloneDeep(this.value as TaskTemplate);
    const dateDeltas = [
      { label: 'Immediately', value: 0 },
      { label: 'After 1 day', value: 1 },
      { label: 'After 2 days', value: 2 },
      { label: 'After 3 days', value: 3 },
      { label: 'After 1 week', value: 7 },
      { label: 'After 2 weeks', value: 14 },
      { label: 'After 1 month', value: 30 },
    ];
    return {
      template,
      validated: <boolean>false,
      invalid: <boolean>false,
      error: <string>'',
      titleTooLong: <boolean>false,
      titleMissing: <boolean>false,
      endBeforeStart: <boolean>false,
      dateDeltas,
      selectedStartDelta: { value: undefined },
      selectedEndDelta: { value: undefined },
    };
  },
  computed: {
    ...mapGetters(['isInstantEmailsOn']),
  },
  watch: {
    template: {
      handler() {
        this.onChange();
      },
      deep: true,
    },
    selectedStartDelta(newDelta) {
      if (newDelta) {
        this.template.startDelta = newDelta.value;
      }
    },
    selectedEndDelta(newDelta) {
      if (newDelta) {
        this.template.endDelta = newDelta.value;
      }
    },
  },
  mounted() {
    this.selectedEndDelta = this.dateDeltas.find(delta => delta.value === this.template.endDelta);
    this.selectedStartDelta = this.dateDeltas.find(delta => delta.value === this.template.startDelta);
  },
  methods: {
    onChange() {
      // Notify parent:
      this.$emit('input', this.template);
      this.slowValid = this.slowValid || debounce(this.validate, 500);
      this.slowValid();
    },
    validate() {
      this.validated = true;
      this.titleMissing = false;
      this.titleTooLong = false;
      this.endBeforeStart = false;
      if (!this.template.active) {
        return true;
      }

      // Custom validation that has to be in sync with backend.
      // Unlike dynamic forms, server can't define validation for each field
      //    as file is saved in json
      let characterBackendLimit = 250;
      this.titleTooLong = this.template.title.length > characterBackendLimit;
      this.error = this.titleTooLong ? `Title is too long` : '';
      this.$refs.title.$el.setCustomValidity(this.error);
      if (this.error) return false;

      if (this.template.startDelta != undefined && this.template.endDelta != undefined) {
        this.endBeforeStart = this.template.endDelta < this.template.startDelta;
        this.error = this.endBeforeStart ? `The end date cannot be before the start date` : '';
        if (this.error) return false;
      }

      this.titleMissing = !(this.$refs.form as HTMLFormElement).checkValidity();
      this.error = this.titleMissing ? 'Missing field' : '';
      return !this.error;
    },
    invalidateCard(error: boolean) {
      // On server-error we outline whole card with red border:
      this.invalid = error;
    },
    getTemplateTooltip() {
      return `You can choose to enable or disable the '${this.template.actionTrigger} template'`;
    },
  },
});
export default RiskTaskTemplate;
